// @ts-nocheck
const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    // position: 'absolute',
    width:'100%',
    height: '10%',
    // marginTop: '5%',
    alignItems: 'center',
    padding: '20px',
    borderWidth: 2,
    borderRadius: 2,
    // borderColor: '#ffffff',
    borderStyle: 'dashed',
    // backgroundColor: '#ffffff',
    color: '#bdbdbd',
    outline: 'none',
    transition: 'border .24s ease-in-out'
  };

export default baseStyle;